export default __webpack_public_path__ + "static/pace-350-specs-1e025809c612a30d155b5d98d9eaeca3.jpg";